<script>
  import EmojiSelector from './EmojiSelector.svelte';
  import {showModal, hideModal} from "../modal/modalStore";
  import {deleteChannel, updateChannel} from "./channelStore";
  import Emoji from "./Emoji.svelte";
  import Dropdown from "../general/Dropdown.svelte";
  import {MenuItem} from "../constants";
  import {showConfirm} from "../popup/popupStore";
  import {showSnackbar} from "../snackbar/snackbarStore";
  import ChannelForm from './ChannelForm.svelte';
  import Modal from "../modal/Modal.svelte";
  import PasscodeInput from "../general/PasscodeInput.svelte";

  export let channel;


  const LOCKING_STEP = {
    ENTER_PASSCODE: Symbol('ENTER_PASSCODE'),
    CONFIRM_PASSCODE: Symbol('CONFIRM_PASSCODE'),
    UNLOCK: Symbol('UNLOCK')
  };

  let enteredPasscode = null;
  let currentLockingStep = null;

  const modalId = 'emoji-selector-' + channel.id;
  const showEmojiSelector = () => {
    showModal(EmojiSelector, {
      id: modalId,
      modalProps: {
        title: 'Emoji for ' + channel.data().name
      },
      contentProps: {
        channel,
        onSelectEmoji: async emoji => {
          updateChannel(channel.id, {emoji});
          hideModal(modalId);
        }
      }
    });
  };

  const lockChannel = () => {
    currentLockingStep = LOCKING_STEP.ENTER_PASSCODE;
  };

  const unlockChannel = () => {
    currentLockingStep = LOCKING_STEP.UNLOCK;
  };

  const closeLockModal = () => currentLockingStep = null;

  const onEnterPasscode = code => {
    switch (currentLockingStep) {
      case LOCKING_STEP.ENTER_PASSCODE:
        enteredPasscode = code;
        currentLockingStep = LOCKING_STEP.CONFIRM_PASSCODE;
        break;
      case LOCKING_STEP.CONFIRM_PASSCODE:
        if (code === enteredPasscode) {
          updateChannel(channel.id, {lockCode: code});
          currentLockingStep = null;
          showSnackbar('Locked');
        } else {
          enteredPasscode = null;
          currentLockingStep = LOCKING_STEP.ENTER_PASSCODE;
          showSnackbar('Codes are not equal');
        }
        break;
      case LOCKING_STEP.UNLOCK:
        if (code === channel.data().lockCode) {
          currentLockingStep = null;
          updateChannel(channel.id, {lockCode: null});
          showSnackbar('Unlocked');
        } else {
          showSnackbar('Wrong code');
        }

    }
  };

  const getDropdownMenuItems = channel => [{
    icon: 'pencil-outline',
    name: 'Edit',
    action: () => {
      const modalId = 'modal-update-channel';
      showModal(ChannelForm, {
        id: modalId,
        modalProps: {width: 300, height: 'auto'},
        contentProps: {
          channel,
          onSubmit: () => hideModal(modalId)
        }
      });
    }
  }, {
    icon: 'archive-outline',
    name: channel.data().archived ? 'Unarchive' : 'Archive',
    action: () => {
      showSnackbar(channel.data().archived ? 'Unarchived' : 'Archived');
      updateChannel(channel.id, {archived: !channel.data().archived});

    }
  }, {
    icon: channel.data().lockCode ? 'lock-open-outline' : 'lock-closed-outline',
    name: channel.data().lockCode ? 'Unlock' : 'Lock',
    action: () => {
      if (channel.data().lockCode) {
        unlockChannel();
      } else {
        lockChannel();
      }
    }
  }, MenuItem.divider, {
    icon: 'trash-outline',
    name: 'Delete',
    color: 'red',
    action: async () => {
      if (!await showConfirm(`Delete channel '${channel.data().name}'? All messages in this channel will be deleted`, {okColor: 'red', okText: 'Delete'})) {
        return;
      }

      return deleteChannel(channel.id);
    }
  }];
</script>


<row align-center expand class="container">
  <button class="button-select-icon clickable" on:click={showEmojiSelector}>
      {#if channel.data().emoji}
        <div class="channel-icon">
          <Emoji emoji={channel.data().emoji}/>
        </div>
      {:else}
        <ion-icon name="scan-outline" class="channel-icon"></ion-icon>
      {/if}
  </button>
  <column expand>
    <div class="channel-name">{channel.data().name}</div>
    {#if channel.data().description}
      <div class="channel-description">{channel.data().description}</div>
    {/if}
  </column>

  <Dropdown limitRight items={getDropdownMenuItems(channel)}>
    <button slot="content" class="button-channel-menu">
      <ion-icon name="ellipsis-horizontal-outline"></ion-icon>
    </button>
  </Dropdown>
</row>

<Modal
        close={closeLockModal}
        visible={!!currentLockingStep}
        title={currentLockingStep === LOCKING_STEP.CONFIRM_PASSCODE ? 'Enter passcode again' : 'Enter passcode'}>
  <svelte:component this={PasscodeInput} style="flex-grow: 1" onComplete={onEnterPasscode} />
</Modal>

<style>
  .container {
    padding: 12px 8px;
  }

  .channel-icon {
    font-size: 20px;
    vertical-align: middle;
  }

  .channel-name {
    font-size: 1.2rem;
    font-weight: bold;
  }

  .channel-description {
    color: #888;
    font-size: .8rem;
    margin-top: 4px;
  }

  .button-select-icon {
    background: none;
    border: none;
  }

  .button-channel-menu {
    background: none;
    border: none;
    width: 32px;
    height: 32px;
    font-size: 20px;
  }


</style>